export default "https://cdn-static.gokick.com/assets/3cd141d05df56e6b81a0153ff619f4101846aa93/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";